import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { Compconf } from '../models/compconf.model';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
@Injectable({
    providedIn: 'root'
  })
export class compconfService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/compconfs/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  }   
  headers = new HttpHeaders().set('Content-Type', 'application/json',);
  currentUser = {};
  window: any;
  private compconfs: Compconf[] = [];
public compconfs$ = new Subject<Compconf[]>();
  constructor(
    private http: HttpClient,
    public router: Router
  ) { }

  createcompconf(compconf: Compconf[]) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.post(`${baseUrl}/createcompconf/`, compconf).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  modifycompconfById(id: string, compconf: Compconf) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.put(`${baseUrl}compconf/${id}`, compconf).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
 /*getcompconfs() {
    return new Promise((resolve, reject) => {
      this.http.get(API_URL_cloud+'allcompconf/').subscribe(
        (compconfs: Compconf[]) => {
          if (compconfs) {
            this.compconfs = compconfs;
            this.emitcompconfs();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    )
  }*/
  getusercompconfs(carte:any) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}filteruserchoice/${carte}`).subscribe(
        (compconfs: Compconf[]) => {
          if (compconfs) {
            this.compconfs = compconfs;
            this.emitcompconfs();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    )
  }
  getuserpluscompconfs(datas:any) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.post(`${baseUrl}filteruserchoice/`,{datas}).subscribe(
        (compconfs: Compconf[]) => {
          if (compconfs) {
            this.compconfs = compconfs;
            this.emitcompconfs();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    )
  }
  getbankcompconfs(dateinf:any,datesup:any,banque:any,carte:any,comm:any,value:any,) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.post(`${baseUrl}filterbankchoice/`,{dateinf,datesup,banque,carte,comm,value}).subscribe(
        (compconfs: Compconf[]) => {
          if (compconfs) {
            this.compconfs = compconfs;
            this.emitcompconfs();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    )
  }
  getportcommcompconfs(dateinf:any,datesup:any,carte:any,comm:any) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.post(`${baseUrl}filterportcommchoice/`,{dateinf,datesup,carte,comm}).subscribe(
        (compconfs: Compconf[]) => {
          if (compconfs) {
            this.compconfs = compconfs;
            this.emitcompconfs();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    )
  }
  emitcompconfs() {
    this.compconfs$.next(this.compconfs);
  }
  getcompconfById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}compconf/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error); 
        }
      );
    });
  }
  deletecompconfById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.delete(`${baseUrl}compconf/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }  
  deletecompconfs() {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.delete(`${baseUrl}allcompconf/`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }


 
  getworgabById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}workgab/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error); 
        }
      );
    });
  }
  deleteworkgabById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.delete(`${baseUrl}workgab/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }  
  deleteWorkgabs() {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();
      this.http.delete(`${baseUrl}allworkgab/`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  //workpos
  
  /*getworkposById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();

      this.http.get(`${baseUrl}workpos/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error); 
        }
      );
    });
  }
  deleteworkposById(id: string) {
    return new Promise((resolve, reject) => {
      this.http.delete(API_URL_cloud+'workpos/'+ id).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }  
  deleteWorkposs() {
    return new Promise((resolve, reject) => {
      this.http.delete(API_URL_cloud+'allworkpos/').subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }


  //worksms
 
  getworksmsById(id: string) {
    return new Promise((resolve, reject) => {
      this.http.get(API_URL_cloud+'worksms/' + id).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error); 
        }
      );
    });
  }
  deleteworksmsById(id: string) {
    return new Promise((resolve, reject) => {
      this.http.delete(API_URL_cloud+'worksms/'+ id).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }  
  deleteWorksmss() {
    return new Promise((resolve, reject) => {
      this.http.delete(API_URL_cloud+'allworksms/').subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }*/
}